import {createAction} from '@reduxjs/toolkit'

export const setModel = createAction('model/setModel')